import { SKTButton } from "../../components/SKTButton";
import { SKTPanel, SKTPanelBody } from "../../components/SKTPanel";
import { Fragment, useState } from "react";
import { SKTTable, SKTTableBody, SKTTableRow } from "../../components/SKTTable";
import { SKTProgressBar } from "../../components/SKTProgressBar";
import { Address } from "../common/Address";
import { LocalizedDateTime } from "../../components/LocalizedDate";
import { SKTToggle } from "../../components/SKTToggle";
import { apiPOST, useAPI } from "../../hooks/APIHook";
import { useData } from "../../hooks/Data";
import { SKTTextField } from "../../components/SKTTextField";
import { SKTAddressField } from "../../components/SKTAddressField";
import { SKTBaseComponent } from "../../components/SKTBaseComponent";
import { SKTForm } from "../../components/SKTForm";
import { API_ENDPOINTS } from "../../config";
import qs from "qs";

const EditAddress = ({ address, prefix, save }) => {
  const prefixed = (key) => `${prefix}${key}`;
  const keyMap = {
    name: prefixed("Name"),
    name2: prefixed("Name2"),
    street: prefixed("Addr1"),
    postal: prefixed("ZIP"),
    phone: prefixed("Phone"),
    email: prefixed("Email"),
    country: prefixed("Country"),
  };
  const defaults = Object.keys(address).reduce((p, key) => {
    p[keyMap[key]] = address[key];
    return p;
  }, {});
  const data = useData({ defaults });

  return (
    <Fragment>
      <SKTForm>
        <SKTAddressField
          corporate={true}
          data={data}
          prefix={prefix}
          label=""
        />
        <SKTBaseComponent>
          <SKTButton label="Tallenna" onClick={() => save(data.values)} />
        </SKTBaseComponent>
      </SKTForm>
    </Fragment>
  );
};

const EditAddressComponent = ({ label, editState, address, save, prefix }) => {
  const [state, setState] = editState;
  return (
    <SKTTableRow label={label}>
      <SKTToggle when={state !== label}>
        <Address address={address} />
        <SKTButton label="Muokkaa" onClick={() => setState(label)} />
      </SKTToggle>
      <SKTToggle when={state === label}>
        <EditAddress prefix={prefix} address={address} save={save} />
      </SKTToggle>
    </SKTTableRow>
  );
};

const EditEvoice = ({ evoice, evoiceint, save }) => {
  const data = useData({ defaults: { evoice, evoiceint } });

  return (
    <SKTForm>
      <SKTTextField data={data} id="evoice" label="Verkkolaskuosoite" />
      <SKTTextField data={data} id="evoiceint" label="Operaattoritunnus" />
      <SKTBaseComponent>
        <SKTButton label="Tallenna" onClick={() => save(data.values)} />
      </SKTBaseComponent>
    </SKTForm>
  );
};

const EditEvoiceComponent = ({ label, editState, evoice, evoiceint, save }) => {
  const [state, setState] = editState;

  return (
    <SKTTableRow label={label}>
      <SKTToggle when={state !== label}>
        <SKTToggle when={evoice}>
          {evoice} (Operaattoritunnus: {evoiceint})
        </SKTToggle>
        <SKTToggle when={!evoice}>
          Verkkolaskuosoitetta ei ole asetettu.
        </SKTToggle>
        <SKTButton label="Muokkaa" onClick={() => setState(label)} />
      </SKTToggle>
      <SKTToggle when={state === label}>
        <EditEvoice evoice={evoice} evoiceint={evoiceint} save={save} />
      </SKTToggle>
    </SKTTableRow>
  );
};

export const AccountInfo = () => {
  const editState = useState("");

  const [accountInfo, refreshAccountInfo] = useAPI(
    API_ENDPOINTS.profile.account
  );
  if (accountInfo.status === "pending")
    return <SKTProgressBar label="Tietoja haetaan" />;
  if (accountInfo.status === "error") return <div>Virhe!</div>;
  if (accountInfo.status === "no_auth")
    return <div>Ei kirjautunut sisään!</div>;

  const customer = accountInfo.customer;

  const save = (values) => {
    apiPOST(API_ENDPOINTS.profile.save, qs.stringify(values)).then((result) => {
      const status = result.data.status;
      if (status === "ok") {
        refreshAccountInfo();
        editState[1]("");
      }
    });
  };

  return (
    <SKTPanel>
      <SKTPanelBody>
        <SKTTable>
          <SKTTableBody>
            <SKTTableRow label="Nimi">{customer.name}</SKTTableRow>
            <SKTTableRow label="Tila">
              {customer.enabled ? "Aktiivinen" : "Suljettu"}
            </SKTTableRow>
            <SKTTableRow label="Tilin muoto">
              {customer.corporate ? "Yritys" : "Yksityishenkilö"}
            </SKTTableRow>
            <SKTToggle when={customer.corporate}>
              <SKTTableRow label="Y-tunnus">{customer.business_id}</SKTTableRow>
            </SKTToggle>
            <EditAddressComponent
              label="Yhteystiedot"
              prefix="iS"
              address={customer.contact}
              save={save}
              editState={editState}
            />

            <SKTToggle when={customer.corporate}>
              <SKTToggle when={customer.billing && !customer.evoice}>
                <EditAddressComponent
                  label="Laskutusosoite"
                  prefix="iB"
                  address={customer.billing}
                  save={save}
                  editState={editState}
                />
              </SKTToggle>
              <EditEvoiceComponent
                label="Verkkolaskutusosoite"
                evoice={customer.evoice}
                evoiceint={customer.evoiceint}
                save={save}
                editState={editState}
              />
            </SKTToggle>

            <SKTTableRow label="Tunnus luotu">
              <LocalizedDateTime datetime={customer.created} />
            </SKTTableRow>
          </SKTTableBody>
        </SKTTable>
      </SKTPanelBody>
    </SKTPanel>
  );
};
